export const OAUTH_POPUP_CALLBACK_MESSAGE_TYPE =
  'altairgql:oauth:callback:response';

export const ALTAIR_API_USER_TOKEN_STORAGE_KEY = 'ALTAIR-API-USER-TOKEN';
